export default __webpack_public_path__ + "static/media/Cootie (1587).d9db6afb.jpg";